import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { cn } from '../../utils/cn';

const toastVariants = {
  success: {
    icon: CheckCircle,
    className: 'bg-green-500 text-white border-green-600',
  },
  error: {
    icon: AlertCircle,
    className: 'bg-red-500 text-white border-red-600',
  },
  warning: {
    icon: AlertTriangle,
    className: 'bg-amber-500 text-white border-amber-600',
  },
  info: {
    icon: Info,
    className: 'bg-blue-500 text-white border-blue-600',
  },
};

const Toast = ({ 
  toast, 
  onDismiss 
}) => {
  const { icon: Icon, className } = toastVariants[toast.type] || toastVariants.info;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -50, scale: 0.95 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className={cn(
        'flex items-center p-4 rounded-lg shadow-lg border min-w-[300px] max-w-md',
        className
      )}
    >
      <Icon className="h-5 w-5 flex-shrink-0 mr-3" />
      <div className="flex-1">
        {toast.title && (
          <p className="font-semibold text-sm">{toast.title}</p>
        )}
        <p className="text-sm opacity-90">{toast.message}</p>
      </div>
      <button
        onClick={() => onDismiss(toast.id)}
        className="ml-3 flex-shrink-0 opacity-70 hover:opacity-100 transition-opacity"
      >
        <X className="h-4 w-4" />
      </button>
    </motion.div>
  );
};

const ToastContainer = ({ toasts = [], onDismiss }) => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      <AnimatePresence>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            toast={toast}
            onDismiss={onDismiss}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export { Toast, ToastContainer, toastVariants };
